import { gql } from '@grandvisionhq/graphql';

const cartAppliedDiscounts = gql`
  fragment CartAppliedDiscountsFragment on Cart {
    cartAppliedDiscounts {
      title {
        locale
        value
      }
      description {
        locale
        value
      }
      code
      type
    }
  }
`;

export { cartAppliedDiscounts };
//# sourceMappingURL=cart-applied-discounts.js.map
